
<ng-template #colorInput let-key>
  <span>
    <input
      class="color-picker-input"
      readonly
      [attr.aria-label]="'Vælg ' + getColorLabel(key)"
      [colorPicker]="getColor(key) || '#ffffff'"
      [cpPosition]="'bottom'"
      [cpOutputFormat]="'hex'"
      (colorPickerChange)="setColor(key, $event)"
      [value]="getColor(key) || '#ffffff'"
      [style.background-color]="getColor(key) || '#ffffff'"
      [style.color]="getTextColor(getColor(key) || '#ffffff')"
    />
  </span>
</ng-template>

<div class="color-settings">

  @for (group of colorGroups; track group.title; let i = $index) {
    <section class="color-group">

      <!-- Group heading -->
      <div class="color-group__title">
        <mat-icon>{{ group.icon }}</mat-icon>
        <h3 class="mb-0">{{ group.title }}</h3>
      </div>

      <!-- Column headings -->
      <div
        class="color-group__header">

        <span>Element</span>
        <span>Farve</span>

        @if (group.paired) {
          <span>Tekst / ikon</span>
        } @else {
          <span></span>
        }
      </div>

      <!-- Color rows -->
      @for (item of group.colors; track item.background) {
        <div
          class="color-pair">

          <div class="color-pair__label">
            <span>{{ getColorLabel(item.background) }}</span>

            <mat-icon
              class="color-pair__help"
              [matTooltip]="getColorExplanation(item.background)"
              matTooltipPosition="above">
              help_outline
            </mat-icon>
          </div>

          <!-- Background / main color -->
          <ng-container
            *ngTemplateOutlet="colorInput;
              context: {$implicit: item.background}">
          </ng-container>

          <!-- Corresponding text color -->
          @if (item.text) {
            <ng-container
              *ngTemplateOutlet="colorInput;
                context: {$implicit: item.text}">
            </ng-container>
          }

        </div>
      }

      <div class="d-flex justify-content-end">
        @if (i === 1) {
          <button
            mat-stroked-button
            color="primary"
            [disabled]="!primaryColor?.value"
            (click)="generateThemeColors()"
            aria-label="Generér container- og tekstfarver"
            [matTooltip]="'Generér container- og tekstfarver ud fra primærfarven: ' + (primaryColor?.value || '')"
            matTooltipPosition="above">

            <mat-icon>palette</mat-icon>
            Generér container farver
          </button>
        }
      </div>

    </section>
  }

</div>
